import Tracker from './Tracker';

const activityOutcomeTracker = new Tracker('activityOutcome', {
	CREATE_EVENT: 'create'
});

export default activityOutcomeTracker;
